import { useEffect } from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import { PermissionEnum, PermissionDenied, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import { useLazyGetBlacklistValidatorsQuery } from './store/services';

import ROUTES from '../../routes';

import cn from './blacklist.module.css';

const Blacklist = (): React.JSX.Element => {
  const navigate = useNavigate();
  const match = useMatch(ROUTES.BLACKLIST);

  const { activePermissions } = useAppSelector(
    (state) => state.amlDictionaries,
  );

  const [getValidators] = useLazyGetBlacklistValidatorsQuery();

  useEffect(() => {
    if (match && activePermissions?.includes(PermissionEnum.BLACKLISTS_LIST)) {
      navigate(ROUTES.BLACKLIST_LIST);
      getValidators();
    }
  }, [match, activePermissions]);

  useEffect(() => {
    let title = 'Block list';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.blacklistLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (
      !activePermissions.includes(PermissionEnum.SECTION_AML_KYC) ||
      !activePermissions.includes(PermissionEnum.BLACKLISTS_LIST)
    ) {
      content = <PermissionDenied />;
    } else {
      content = (
        <div className={cn.blacklist}>
          <Outlet />
        </div>
      );
    }
  }

  return content;
};

export default Blacklist;
